module.exports = __webpack_public_path__ + "static/media/minus.c24258a7.svg";